var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagRu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0D820AD-66A9-4467-BB46-78181AED70FA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registruokit\\u0117s-vizitui",
    transform: "translate(-809.000000, -531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(515.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LT_flag-Copy-4",
    transform: "translate(294.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,7 L27,7 L0,7 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#0033A0",
    x: 0,
    y: 6,
    width: 27,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12 L27,12 L27,16 C27,17.1045695 26.1045695,18 25,18 L2,18 C0.8954305,18 1.3527075e-16,17.1045695 0,16 L0,12 L0,12 Z",
    id: "Rectangle-Copy-2",
    fill: "#DA291C"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRu);
export default __webpack_public_path__ + "static/media/flag-ru.69f1003f7816163b8bf05e281c574b74.svg";
export { ForwardRef as ReactComponent };